/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { ClearanceCaseSetStatusResponseJson } from './clearance-case-set-status-response-json';
import { ClearanceCaseSetStatusResult } from '../results/clearance-case-set-status-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseStatus } from '../enums/clearance-case-status.enum';
import { ClearanceCaseCustomerStatus } from '../enums/clearance-case-customer-status.enum';
import { ClearanceCaseDto } from '../models/clearance-case-dto';
import { ClearanceCaseValidationError } from '../enums/clearance-case-validation-error.enum';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class ClearanceCaseSetStatusResponse extends ResponseWithErrorGeneric<ClearanceCaseSetStatusResponseJson, ClearanceCaseSetStatusResult> implements IResponseWithErrorGeneric<ClearanceCaseSetStatusResult> {
  public status: ClearanceCaseStatus;
  public customerStatus: ClearanceCaseCustomerStatus;
  public clearanceCase: ClearanceCaseDto;
  public validationErrors: ClearanceCaseValidationError[];

  //<custom-body>
  constructor(response: HttpResponse<ClearanceCaseSetStatusResponse>) {
    super(response, ClearanceCaseSetStatusResult.Error);

    if (this.result === ClearanceCaseSetStatusResult.ValidationError) {
      this.validationErrors = this.body.validationErrors;
    }

    if (this.result !== ClearanceCaseSetStatusResult.Success) {
      return;
    }

    this.status = this.body.status;
    this.customerStatus = this.body.customerStatus;
    this.clearanceCase = this.body.clearanceCase;
  }

  public get hasValidationError(): boolean {
    return this.result === ClearanceCaseSetStatusResult.ValidationError;
  }

  public get hasError(): boolean {
    return !this.hasValidationError && !this.hasSuccess;
  }

  public get hasSuccess(): boolean {
    return this.result === ClearanceCaseSetStatusResult.Success;
  }
  //</custom-body>
}
